import React from "react";
import styles from './loader.module.scss';

interface LoaderProps {
  size?: number;
  color?: string;
  inline?: boolean;
  classNameLoader?: string;
  classNameContainer?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 20, color = "#2e1a47", inline = false, classNameLoader = '', classNameContainer = '' }) => {
  return (
    <div
      className={`${styles.loaderContainer} ${inline ? styles.inline : ''} ${classNameContainer}`}
      style={{ width: size, height: size }}
    >
      <div
        className={`${styles.loader} ${classNameLoader}`}
        style={{ borderTopColor: color, width: size, height: size }}
      ></div>
    </div>
  );
};

export default Loader;
